import * as React from 'react';
import { SvgWrapper } from '../utils';
import type { IconProps } from '../utils';

const svg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x={0}
    y={0}
    viewBox="0 0 500 500"
    xmlSpace="preserve"
    width="1em"
    height="1em"
  >
    <circle cx={250} cy={250.5} r={250} fill="#30302f" />
    <path
      d="M373.408 266.453a12.338 12.338 0 00-8.767-3.682l-105.78-.466-.057-.001c-6.825 0-12.394 5.538-12.424 12.372l-.085 16.69-19.449-.086.085-16.69a12.338 12.338 0 00-3.604-8.8 12.338 12.338 0 00-8.767-3.68l-105.78-.468h-.057c-3.293 0-6.397 1.28-8.743 3.605a12.34 12.34 0 00-3.68 8.767l-.173 38.857c-.03 7.035 2.694 13.676 7.67 18.697 4.978 5.021 11.594 7.803 18.629 7.834l77.802.343.12.001c6.991 0 13.585-2.722 18.577-7.67 5.021-4.977 7.804-11.593 7.835-18.629l.032-6.682 19.448.086-.031 6.682c-.032 7.035 2.692 13.676 7.67 18.697 4.978 5.021 11.594 7.804 18.628 7.834l77.803.343.119.001c14.51 0 26.348-11.773 26.412-26.299l.171-38.856a12.338 12.338 0 00-3.604-8.8zm-162.426 46.925c-.013 2.82-1.137 5.48-3.165 7.49-2.017 2-4.668 3.099-7.471 3.099h-.048l-77.803-.343c-5.865-.026-10.614-4.819-10.59-10.684l.158-35.504 99.074.437-.155 35.505zm150.08.662c-.026 5.849-4.791 10.589-10.634 10.589h-.049l-77.802-.343c-2.821-.013-5.482-1.136-7.492-3.164-2.01-2.029-3.11-4.699-3.098-7.52l.157-35.504 99.075.437-.156 35.505z"
      fill="#878788"
    />
    <path
      d="M201.321 146.876c-11.12 0-20.817 4.025-29.647 12.304-2.344 2.199-7.73 8.516-14.547 16.515-9.733 11.42-21.848 25.632-33.246 37.512-7.56 7.88-19.525 14.595-28.87 18.537h68.233c11.183 0 21.696-4.356 29.603-12.263l41.542-41.542 1.326-1.326 1.325-1.325 28.412-28.412h-64.13z"
      fill="#3cbca0"
    />
    <path fill="#2d8f44" d="M344.744 188.091h81.472l10.204-10.203h-81.473z" />
    <path
      d="M338.957 193.878l-1.326 1.326-35.748 35.748-.79.791h64.13a42.29 42.29 0 0010.322-1.277 41.34 41.34 0 002.07-.582c6.428-1.983 12.32-5.511 17.212-10.404l26.048-26.048h-81.472l-.446.446z"
      fill="#3cbca0"
    />
    <path
      d="M467.432 146.876h-64.13c-10.127 0-19.697 3.581-27.288 10.127h81.291l10.127-10.127z"
      fill="#86ca90"
    />
    <path fill="#52ad63" d="M370.491 162.344l-10.203 10.203h81.473l10.203-10.203z" />
    <g>
      <path
        d="M301.566 159.138c-7.513-7.513-17.388-11.77-27.944-12.181l-32.808 32.902 39.622 39.621a41.711 41.711 0 0015.06 9.668l37.985-38.094-31.915-31.916z"
        fill="#1c928e"
      />
    </g>
  </svg>
);

const Seqgeq = ({
  style = {
    primaryColor: 'currentColor',
    bgColor: 'transparent',
  },
  size = '1em',
  active = false,
  ...rest
}: IconProps) => (
  <SvgWrapper style={style} size={size} active={active} {...rest}>
    {svg}
  </SvgWrapper>
);

export default Seqgeq;
